module.exports = "/matchcenter-staging/assets/images/ote_sport_7.2afce5c065ee5ebb77103abc05be63ae.png";